import { Component } from '@angular/core';

@Component({
  selector: 'app-solution',
  templateUrl: './solution.component.html',
  styleUrls: ['./solution.component.scss']
})
export class SolutionComponent {
  manetPdfs = [
    { name: 'MMESH OEM BD-C352-2', path: 'assets/pdfs/MMESH OEM BD-C352-2.pdf' },
    { name: 'MMESH 2W BODYWORN MK3', path: 'assets/pdfs/MMESH 2W BODYWORN MK3.pdf' },
    { name: 'MMESH 2W COMMANDER NODE RBT2-100150', path: 'assets/pdfs/MMESH 2W COMMANDER NODE RBT2-100150.pdf' },
    { name: 'MMESH 2W Robust Product M-RBT2', path: 'assets/pdfs/MMESH 2W Robust Product M-RBT2.pdf' },
    { name: 'MMESH 10W Robust S-M-RBT2-10', path: 'assets/pdfs/MMESH 10W Robust S-M-RBT2-10.pdf' },
    { name: 'MMESH 500mW COVERT', path: 'assets/pdfs/MMESH 500mW COVERT.pdf' },
    { name: 'MMESH 500mW PTT', path: 'assets/pdfs/MMESH 500mW PTT.pdf' },
    { name: 'MMESH M-RBTLC-500', path: 'assets/pdfs/MMESH M-RBTLC-500.pdf' },
    { name: 'MMESH OEM BD-C203', path: 'assets/pdfs/MMESH OEM BD-C203.pdf' },
    { name: 'MMESH OEM BD-C206', path: 'assets/pdfs/MMESH OEM BD-C206.pdf' },
    { name: 'MMESH OEM BD-C206T', path: 'assets/pdfs/MMESH OEM BD-C206T.pdf' },
    { name: 'MMESH OEM BD-C303', path: 'assets/pdfs/MMESH OEM BD-C303.pdf' },
    { name: 'MMESH OEM BD-C352-1', path: 'assets/pdfs/MMESH OEM BD-C352-1.pdf' }
  ];
    images = [
    'assets/images/solutions/IMG_1044.jpeg',
    'assets/images/solutions/IMG_5598.jpeg',
    'assets/images/solutions/IMG_1037.jpeg',
    'assets/images/solutions/IMG_5599.jpeg'
  ];
     mroimages = [
    'assets/images/MRO/MRO1.jpeg',
    'assets/images/MRO/mro2.jpeg',
    'assets/images/MRO/mro3.jpeg',
    'assets/images/MRO/mro4.jpeg'
  ];
    proimages = [
    'assets/images/ps.jpg',
    'assets/images/ps2.jpg',
    
  ];

    isSectionOpen = {
    shortRange: false,
    mediumRange: false,
    longRange: false,
    ops: false,
    strategy: false,
    detection: false,
    licensing: false,
    manufacturing: false,
    mro: false,
    isr: false,
    borderSecurity: true ,
     isrDatasheets: false,
  isrMedia: false,
  protectiveservices :false,
  ov:false ,
  core: false,
  op: false,
  am: false,
  mg:false,
  sdo:false,
  };

  toggleSection(section: string) {
    this.isSectionOpen[section] = !this.isSectionOpen[section];
  }

  currentIndex = 0;

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
  }

  prevSlide() {
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
  }

  goToSlide(index: number) {
    this.currentIndex = index;
  }


currentSlide = 0;

nextmrSlide() {
  this.currentIndex = (this.currentIndex + 1) % this.mroimages.length;
}

prevmrSlide() {
  this.currentIndex = (this.currentIndex - 1 + this.mroimages.length) % this.mroimages.length;
}

}
